"use strict";
import React from "react";
import PropTypes from "prop-types";
import FormsyFields from "./formsyFields";

class JSONEditor extends React.Component {

    static propTypes = {
        name: PropTypes.string.isRequired
    }

    static defaultProps = {
        label: '',
        rows: 10,
        help: null,
        onChange: () => { }
    }

    changeValue(event) {
        const json = event.currentTarget.value;

        try {
            const value = JSON.parse(json);
            this.props.onSetValue(value);
            this.props.onChange(this.props.name, value);
        } catch (e) {
            this.props.onSetValue(json);
        }
    }

    renderElement() {
        const {
            isPristine, layout, help, elementWrapperClassName, labelClassName,
            rowClassName, errorMessages, showErrors, onSetValue, ...restProps
        } = this.props;

        const isString = typeof this.props.value === "string";
        const val = isString ? this.props.value : JSON.stringify(this.props.value, null, 4)
        var className = isString ? "form-control error" : "form-control";

        return (
            <div>
                <textarea ref="element"
                    className={className}
                    {...restProps}
                    id={this.props.id}
                    label={null}
                    value={val}
                    onChange={this.changeValue.bind(this)}
                    disabled={this.props.disabled} />
            </div>
        );
    }

    render() {

        const className = this.props.required ? 'required' : this.props.showErrors ? 'error' : null;

        if (this.props.layout === 'elementOnly') {
            return (
                <div className={className}>{this.renderElement()}</div>
            );
        }

        return (
            <FormsyFields.Row
                label={this.props.label}
                rowClassName={this.props.rowClassName}
                labelClassName={this.props.labelClassName}
                elementWrapperClassName={this.props.elementWrapperClassName}
                layout={this.props.layout}
                required={this.props.required}
                showErrors={this.props.showErrors}
                fakeLabel={true}
            >
                <div className={className}>
                    {this.renderElement()}
                    {this.props.help && <FormsyFields.Help help={this.props.help} />}
                    {this.props.showErrors && <FormsyFields.ErrorMessages messages={this.props.errorMessages || []} />}
                </div>
            </FormsyFields.Row>
        );
    }
}

module.exports = FormsyFields.FormsyReactComponent(JSONEditor);